import graphql__be0ee75a5386dfcb0da8 from "./__generated__/ContributionsMapNewContributionDraggableElement_style.graphql.js";import { useMemo } from "react";
import ReactDOMServer from "react-dom/server";
import { graphql, useFragment } from "react-relay";
import { DragPreviewImage } from "react-dnd";

import MapElementImage from "../../../Maps/MapElementImage";

// This component is used to show a draggable element. As we use a font icon for our
// draggable marker element, react-dnd seems to have an issue with the drag preview of
// such an element, so we had to use their `<DragPreviewImage>` component and render
// a data-URI SVG string to provide it to its `src` prop.
//
const ContributionsMapNewContributionDraggableElement = props => {
  const style = useFragment(
    ContributionsMapNewContributionDraggableElement_style,
    props.style
  );
  const { dragPreviewRef } = props;

  // If the style was set to a font icon, we use its CSS computed :before pseudo-class
  // "content" value to determine the character that we'll need to use inside the SVG
  // <text> element to display the right icon.
  const iconCharacter = useMemo(() => {
    if (!style.iconClass) return;

    // Create the icon tag and append it to the DOM
    const iconTag = document.createElement("i");
    iconTag.classList.add(style.iconClass);
    document.body.appendChild(iconTag);
    // Fetch the "content" property of the css rule
    const sourceCharacter = window
      .getComputedStyle(iconTag, ":before")
      .getPropertyValue("content");
    // Remove the placeholder element from the DOM
    iconTag.remove();
    // Remove the quotes from the character string and return it
    return sourceCharacter?.replace(/"/g, "");
  }, [style.iconClass]);

  // This is not used for now, but if we allow customizing the element to drag we'll need
  // to handle this case. The below code did work in previous tests, so we keep it here
  // so that adding the customization to the back-office should just work.
  if (style.image) {
    return (
      <div
        ref={dragPreviewRef}
        dangerouslySetInnerHTML={{
          __html: MapElementImage({
            ...style,
            position: "static"
          })
        }}
      />
    );
  }

  // For the moment, we use a fixed marker icon, but with some work we could make the icon
  // configurable by using the `style.iconClass` to infer the UTF8 character to provide
  // inside the <text> tag.
  const svgNode = (
    <svg xmlns="http://www.w3.org/2000/svg" width={style.width} height={style.height}>
      <text
        x="0"
        style={{ fontFamily: "JenparleIcons", fontSize: style.height }}
        fill={style.color}
        y={style.height}
      >
        {iconCharacter}
      </text>
    </svg>
  );

  const svgString = ReactDOMServer.renderToString(svgNode);
  const src = `data:image/svg+xml;utf8,${svgString}`;

  return (
    <>
      <DragPreviewImage src={src} connect={dragPreviewRef} />
      {svgNode}
    </>
  );
};

const ContributionsMapNewContributionDraggableElement_style = graphql__be0ee75a5386dfcb0da8;

export default ContributionsMapNewContributionDraggableElement;
